import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import { auth } from "../service/firebase";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

function ProfileRight() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    auth.onAuthStateChanged(function (authUser) {
      if (authUser) {
        // User is signed in.
        setUser(authUser);
      } else {
        // No user is signed in.
        setUser(null);
      }
    });
  }, [user]);

  const classes = useStyles();

  return (
    <div className="d-flex justify-content-around align-items-center">
      <Avatar
        alt={user?.displayName ? user.displayName : ""}
        src={user?.photoURL ? user.photoURL : "/static/images/avatar/1.jpg"}
        className={classes.large}
      />
      <h2 className="ml-3"> {user ? user.displayName : "Login/Register"}</h2>
    </div>
  );
}

export default ProfileRight;
